
import { Component, Vue } from 'vue-property-decorator';
import { BASE_API_URL, REXQO_APP_ID } from '@/constants';
import { httpStore, currentUserStore } from '@/store/typed';
import PrintAreaCustomization from '@/models/PrintAreaCustomization';
export enum PrintAreaCustomizationMixinTags {
	Show = "ShowPrintAreaCustomization",
	Create = "CreatePrintAreaCustomization",
	Upload = "UploadPrintAreaCustomization",
	UploadAsync = "UploadPrintAreaCustomizationAsync",
}

@Component
export default class PrintAreaCustomizationMixin extends Vue {

	uploadPrintAreaCustomization(uuid: string, data: any) {
		const url = `${BASE_API_URL}print_area_customizations/${uuid}/upload`;
		return httpStore.request({
			tag: PrintAreaCustomizationMixinTags.Upload,
			url: url,
			data: data,
			headers: {'x-app-id': REXQO_APP_ID,  'locale': currentUserStore.lang},
			method: 'POST',
			cancelToken: httpStore.source.token
			}) as Promise<PrintAreaCustomization>;
	}
	
	uploadPrintAreaCustomizationAsync(uuid: string, data: any) {
		const url = `${BASE_API_URL}print_area_customizations/${uuid}/upload_async`;
		return httpStore.request({
			tag: PrintAreaCustomizationMixinTags.UploadAsync,
			url: url,
			data: data,
			headers: {'x-app-id': REXQO_APP_ID,  'locale': currentUserStore.lang},
			method: 'POST',
			cancelToken: httpStore.source.token
			}) as Promise<PrintAreaCustomization>;
	}
}
